import {checkIfUnitMeleeElf} from "../factions/elves/checkIfUnitMeleeElf";

/**
 * Владельцы того, по чему действительно бьет выстрел, — против кого бросаются
 * его кости: для штрафа форы новичкам (см. getLowRatingAdvantageDicePenalty),
 * для подкрутки костей бота и снятия ее при выстреле по боту (см.
 * getBotCombatD6MinRoll, checkIfAnyOpponentIsBot).
 *
 * Катапульта стреляет по ячейке: одним броском достается и отряду на ней, и
 * строению — противники и владелец отряда-цели, и владелец ячейки. Выстрел
 * эльфов наносит урон только отряду, строение не трогает: владелец ячейки в
 * нем не участвует. Тот же набор целей берет сам расчет урона (см.
 * calculateShootingDamage). Без этого фора новичка ослабляла бы выстрел
 * эльфов по ЧУЖОМУ отряду, стоящему в его городе, — то есть защищала бы того,
 * кто этот город осаждает.
 *
 * @param {Object} shooter - стреляющий отряд
 * @param {string|null} targetUnitOwnerId - владелец отряда-цели (null — цель не отряд)
 * @param {string|null} targetHexOwnerId - владелец ячейки-цели (null — ничья)
 * @returns {Array<string|null>}
 */
export const getShotOpponentOwnerIds = (shooter, targetUnitOwnerId, targetHexOwnerId) => (
  checkIfUnitMeleeElf(shooter)
    ? [targetUnitOwnerId]
    : [targetUnitOwnerId, targetHexOwnerId]
);
